<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="loadData">
        <a-row :gutter="12">
          <a-col :md="8" :sm="10">
            <a-form-item label="日期范围">
              <a-range-picker
                v-model="queryParam.dateRange"
                format="YYYY-MM-DD"
                style="width: 100%"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item label="产品">
              <a-select v-model="queryParam.appSsid" allowClear placeholder="全部产品" style="width: 100%">
                <a-select-option v-for="item in appList" :key="item.appssid" :value="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="search" @click="loadData">查询</a-button>
              <a-button icon="reload" style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="false"
      :scroll="{ x: 1625 }"
      :rowKey="(r, i) => i"
      size="small"
      bordered
      :rowClassName="rowClass"
    />
  </div>
</template>

<script>
import { queryAdSpendReport } from '@/webpublicapi/adSpendReport'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment'

// 单价/成本 = 花费 / 数量（前端计算，后端只提供花费和各数量）
function costPer (cost, count) {
  if (cost == null || count == null || Number(count) === 0) return '-'
  return '$' + (Number(cost) / Number(count)).toFixed(2)
}
// 比率 = 分子 / 分母 * 100%
function ratePct (num, den) {
  if (num == null || den == null || Number(den) === 0) return '-'
  return (Number(num) / Number(den) * 100).toFixed(1) + '%'
}
// 是否合计行（渠道合计 / 总合计）
function isTotal (row) {
  return row.rowType === 'TOTAL' || row.rowType === 'GRAND_TOTAL'
}

export default {
  name: 'AdSpendReport',
  data () {
    return {
      loading: false,
      queryParam: {
        dateRange: [moment().subtract(1, 'days'), moment()],
        startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        appSsid: undefined
      },
      appList: [],
      dataSource: [],
      columns: [
        {
          title: '产品名', dataIndex: 'appName', width: 140, fixed: 'left', ellipsis: true,
          customRender: (text, row) => {
            if (row.rowType === 'GRAND_TOTAL') return '总合计'
            if (row.rowType === 'TOTAL') return '渠道合计'
            return text
          }
        },
        { title: '日期', dataIndex: 'dataDt', width: 100 },
        {
          title: '渠道', dataIndex: 'channel', width: 110,
          customRender: (text, row) => row.rowType ? '' : (text || '-')
        },
        {
          title: '花费金额', dataIndex: 'networkCost', width: 100,
          customRender: text => text != null ? '$' + Number(text).toFixed(2) : '-'
        },
        { title: '安装', dataIndex: 'installs', width: 70 },
        {
          title: '安装成本', dataIndex: 'installCost', width: 90,
          customRender: (text, row) => costPer(row.networkCost, row.installs)
        },
        { title: '注册', dataIndex: 'regCount', width: 65 },
        { title: '申贷', dataIndex: 'applyCount', width: 65 },
        {
          title: '申贷成本', dataIndex: 'applyCost', width: 85,
          customRender: (text, row) => costPer(row.networkCost, row.applyCount)
        },
        { title: '风控', dataIndex: 'creditGrantedCount', width: 65 },
        {
          title: '风控成本', dataIndex: 'riskCost', width: 85,
          customRender: (text, row) => costPer(row.networkCost, row.creditGrantedCount)
        },
        {
          title: '申请放款率', dataIndex: 'loanRate', width: 95,
          customRender: (text, row) => ratePct(row.loanCount, row.applyCount)
        },
        { title: '下款新户', dataIndex: 'loanCount', width: 75 },
        {
          title: '放款单价', dataIndex: 'loanCost', width: 80,
          customRender: (text, row) => costPer(row.networkCost, row.loanCount)
        },
        {
          title: '实际放款数量', dataIndex: 'actualLoanCount', width: 100,
          customRender: (text, row) => isTotal(row) ? (text != null ? text : 0) : ''
        },
        {
          title: '实际放款单价', dataIndex: 'actualLoanCost', width: 100,
          customRender: (text, row) => isTotal(row) ? costPer(row.networkCost, row.actualLoanCount) : ''
        }
      ]
    }
  },
  created () {
    getApplistExcludingSubApp().then(res => {
      this.appList = res.data || []
    })
    this.loadData()
  },
  methods: {
    onDateChange (dates, dateStrings) {
      this.queryParam.startDate = dateStrings[0]
      this.queryParam.endDate = dateStrings[1]
    },
    resetQuery () {
      this.queryParam = {
        dateRange: [moment().subtract(1, 'days'), moment()],
        startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        appSsid: undefined
      }
      this.loadData()
    },
    loadData () {
      this.loading = true
      const params = {
        startDate: this.queryParam.startDate,
        endDate: this.queryParam.endDate,
        appSsid: this.queryParam.appSsid
      }
      queryAdSpendReport(params).then(res => {
        if (res.code === 1000) {
          this.dataSource = res.data || []
        } else {
          this.dataSource = []
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.dataSource = []
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    rowClass (record) {
      if (record.rowType === 'GRAND_TOTAL') return 'row-grand-total'
      if (record.rowType === 'TOTAL') return 'row-total'
      return ''
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
/deep/ .row-total td {
  background: #e6f7ff !important;
  font-weight: 600;
}
/deep/ .row-grand-total td {
  background: #fff7e6 !important;
  font-weight: 700;
}
</style>
